import * as XLSX from 'xlsx';
import { applyColumnWidths } from './columnWidthCalculator';

interface ISnapshotMicroArea {
  daily_metrics: {
    date: string;
    average_instant_capacity_rate: number;
    average_consumption_kg_per_animal: number;
    average_consumption_g_per_kg_pv: number;
    cumulative_productivity: number;
  }[];
}

export const exportPastureManagementDataToExcel = (
  snapshotMicroAreaMetrics: ISnapshotMicroArea,
  startDate?: Date,
  endDate?: Date
) => {
  if (!snapshotMicroAreaMetrics || !snapshotMicroAreaMetrics.daily_metrics || snapshotMicroAreaMetrics.daily_metrics.length === 0) {
    throw new Error('Dados insuficientes para exportação');
  }

  const workbook = XLSX.utils.book_new();

  const metricsData = snapshotMicroAreaMetrics.daily_metrics.map((item) => ({
    'Data': item.date,
    'Taxa de lotação instantânea (UA/ha)': parseFloat(item.average_instant_capacity_rate.toFixed(2)),
    'Consumo médio (kg/cab.dia)': parseFloat(item.average_consumption_kg_per_animal.toFixed(2)),
    'Consumo médio (g/kgPV.dia)': parseFloat(item.average_consumption_g_per_kg_pv.toFixed(2)),
    'Produtividade acumulada (Kg PV/ha)': parseFloat(item.cumulative_productivity.toFixed(2))
  }));

  const totalCount = snapshotMicroAreaMetrics.daily_metrics.length;
  const totalRow = {
    'Data': 'Média',
    'Taxa de lotação instantânea (UA/ha)': parseFloat((snapshotMicroAreaMetrics.daily_metrics.reduce((acc, item) => acc + item.average_instant_capacity_rate, 0) / totalCount).toFixed(2)),
    'Consumo médio (kg/cab.dia)': parseFloat((snapshotMicroAreaMetrics.daily_metrics.reduce((acc, item) => acc + item.average_consumption_kg_per_animal, 0) / totalCount).toFixed(2)),
    'Consumo médio (g/kgPV.dia)': parseFloat((snapshotMicroAreaMetrics.daily_metrics.reduce((acc, item) => acc + item.average_consumption_g_per_kg_pv, 0) / totalCount).toFixed(2)),
    'Produtividade acumulada (Kg PV/ha)': parseFloat((snapshotMicroAreaMetrics.daily_metrics.reduce((acc, item) => acc + item.cumulative_productivity, 0) / totalCount).toFixed(2))
  };

  const metricsWorksheet = XLSX.utils.json_to_sheet([...metricsData, totalRow]);
  applyColumnWidths(metricsWorksheet, [...metricsData, totalRow]);
  XLSX.utils.book_append_sheet(workbook, metricsWorksheet, 'Métricas Diárias');

  const excelBuffer = XLSX.write(workbook, { 
    bookType: 'xlsx', 
    type: 'array' 
  });

  const blob = new Blob([excelBuffer], { 
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
  });
  
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  
  let filename = 'manejo-pasto-geral';
  if (startDate && endDate) {
    const startStr = startDate.toISOString().split('T')[0];
    const endStr = endDate.toISOString().split('T')[0];
    filename = `manejo-pasto-geral-${startStr}-${endStr}.xlsx`;
  } else {
    filename = `manejo-pasto-geral-${new Date().toISOString().split('T')[0]}.xlsx`;
  }
  
  link.download = filename;
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

